import { ref} from "vue";

export function useExpenseEnums() {


    const expenseTypesEnums = ref({
        REPORT: 'REPORT',
        TRAVEL: 'TRAVEL',
        OFFICE: 'OFFICE'
    })

    const expenseStatusEnums = ref({
        DRAFT: 'DRAFT',
        UNVALIDATED: 'UNVALIDATED',
        REJECTED: 'REJECTED',
        APPROVED: 'APPROVED',
        VALIDATED: 'VALIDATED',
        PARTIALLY_PAID: 'PARTIALLY_PAID',
        PAID: 'PAID',
    })


    return { expenseTypesEnums, expenseStatusEnums }
}
